import type { Awning } from "building-types/openings/awning";
import type { AwningSettings } from "building-types/settings/awningSettings";
import { AwningType } from "building-types/settings/settingsTypesEnum";
import type { DocMigration } from "../docMigration";

interface AwningPlacement {
  readonly awning?: Awning;
  readonly awningSettings?: Partial<AwningSettings>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_118: DocMigration = {
  maxSchemaVersion: "0.0.118",
  description: "Awning Settings Updates",
  apply(json: any) {
    if (json?.roomLayouts) {
      for (const key in json.roomLayouts) {
        const roomLayout = json.roomLayouts[key];
        if (!roomLayout?.openingPatterns) {
          continue;
        }
        for (const openingPattern of roomLayout.openingPatterns) {
          if (!openingPattern?.openings) {
            continue;
          }
          for (const opening of openingPattern?.openings) {
            migrateAwningPlacement(opening);
          }
        }
      }
    }

    if (json?.dormers) {
      for (const key in json.dormers) {
        const dormer = json.dormers[key];
        migrateAwningPlacement(dormer);
      }
    }

    if (json?.gableOpenings) {
      for (const key in json.gableOpenings) {
        const gableOpening = json.gableOpenings[key];
        migrateAwningPlacement(gableOpening);
      }
    }
    return json;
  },
};

export default migration_0_0_118;

function migrateAwningPlacement(placement: AwningPlacement) {
  const awning = placement?.awning;
  if (!awning) {
    (placement as any).awningSettings = { awningType: AwningType.DISABLED };
    return;
  }
  const awningSettings: Partial<AwningSettings> = {};
  let hasAwningTypeProperty = false;
  for (const propertyName of Object.keys(awning)) {
    if (propertyName === "startOffset" || propertyName === "endOffset" || propertyName === "offsetsNormalized") {
      continue;
    }
    if (propertyName === "awningType") {
      hasAwningTypeProperty = true;
    }

    awningSettings[propertyName] = awning[propertyName];
    delete awning[propertyName];
  }

  if (Object.keys(awningSettings).length === 0) {
    (placement as any).awningSettings = awningSettings;
    return;
  }
  if (!hasAwningTypeProperty) {
    (awningSettings as any)["awningType"] = AwningType.DISABLED;
  }
  (placement as any).awningSettings = awningSettings;
}
